module.exports = "https://static.energy5.com/_next/static/images/rightBottomGridAboutImage-84454f6465c3f5bd941ccd8b34afcf0a.jpg";